// extracted by mini-css-extract-plugin
export default {"LinkSection":"LinkSection_LinkSection__058y+","List":"LinkSection_List__QqGU5","Link":"LinkSection_Link__wGLh3"};